import { RootStore } from '~/stores/root.store';

const APPSFLYER_HONEYBOOK_PROD_LINK =
    'https://honeybook.onelink.me/850908038/vt5ieyei';
const APPSFLYER_HONEYBOOK_STAGING_LINK =
    'https://honeybook-testing.onelink.me/5AWP/62v3l8ox';

export class AppsFlyerService {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    getOneline(): string {
        const { configStore } = this.rootStore;
        return configStore.isProduction()
            ? APPSFLYER_HONEYBOOK_PROD_LINK
            : APPSFLYER_HONEYBOOK_STAGING_LINK;
    }
}
